import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import MuiDialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { dialogStyles } from "../../../theme/dialogStyles";
import PrepFqScoreGraph from "./PrepFqScoreGraph";

interface OwnProps {
  open: boolean;
  setOpen(open: boolean): any;
}
type Props = OwnProps;

const PrepFqScoreGraphModal: React.FC<Props> = ({ open, setOpen }) => {
  const classes = dialogStyles();
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted={false}
      maxWidth="lg"
      fullWidth
    >
      <MuiDialogTitle className={classes.root}>
        <Typography variant="h3"></Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
      <DialogContent style={{ padding: 0, overflow: "unset" }}>
        <PrepFqScoreGraph />
      </DialogContent>
    </Dialog>
  );
};

export default PrepFqScoreGraphModal;
